import { render } from "./GuideCodeTabs.vue?vue&type=template&id=37ff4241"
import script from "./GuideCodeTabs.vue?vue&type=script&lang=js"
export * from "./GuideCodeTabs.vue?vue&type=script&lang=js"

import "./GuideCodeTabs.vue?vue&type=style&index=0&id=37ff4241&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab,QBtn,QTooltip});
